<template>
    <v-text-field
            :error="errorHighlight"
            :id="id"
            v-model="value"
            v-bind="$attrs"
            @input="onInput"
            :readonly="readonly"
            outlined
            :required="required">
        <template v-slot:label>
            {{ labelRequired }}
        </template>
    </v-text-field>
</template>

<script>

import InputField from '@/components/Core/Input/Core/Input'

export default {
  extends: InputField,
  components: {
  },
  name: 'TextInput',
  props: {
    uppercase: {
      type: Boolean,
      default: false
    },
    valueP: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'valueP',
    event: 'change'
  },
  data () {
    return {
      value: this.valueP
    }
  },
  methods: {
    onInput (value) {
      if (this.uppercase) {
        value = value.toUpperCase()
      }

      this.$emit('input', value)

      this.value = value
    }
  },
  watch: {
    value: function (newValue) {
      this.$emit('change', newValue)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
